<template>
  <MentionCard
    class="pointer"
    :list-title="listTitle"
    :logo="mention.source ? mention.source.logo_url : null"
    :mention="mention"
    :mentions="mentions"
    :options="options"
    :selected="selected"
    :show-checkbox="showCheckbox"
    :stream="stream"
    :title="mention.title"
    @click="$emit('click', $event)"
    @mention-selected="$emit('mention-selected', $event)"
  >
    <template #before>
      <div
        v-if="mention.thumbnails && mention.thumbnails.length"
        class="row items-start"
      >
        <img
          :alt="$t('tv_segment_mention_card.tv_thumbnails')"
          class="thumbnail"
          :src="mention.thumbnails[0].url"
        />
        <img
          v-if="mention.thumbnails.length >= 2"
          :alt="$t('tv_segment_mention_card.tv_thumbnails')"
          class="thumbnail"
          :src="mention.thumbnails[1].url"
        />
      </div>
    </template>

    <template #header>
      <span>
        <strong class="bigger2">
          {{ mention.source.name }}
        </strong>
        {{ mention.source.location }}
      </span>
      <span>
        <TimeAgo
          class="soft"
          :date="mention.timestamp"
        />
        <span v-if="mention.program_airing">
          · {{ mention.program_airing.name }}
        </span>
      </span>
    </template>

    <slot />
  </MentionCard>
</template>

<script>
import TimeAgo from "shared/components/core/various/TimeAgo.vue";
import { MentionCard, propsExcept } from "shared/components/MentionCard";

export default {
  name: "TVSegmentMentionCard",
  components: {
    MentionCard,
    TimeAgo,
  },
  props: {
    ...propsExcept(["listTitle"]),
  },
  emits: ["click", "mention-selected"],
  computed: {
    listTitle() {
      const mentionTitle = this.mention.program_airing
        ? this.mention.program_airing.name
        : this.mention.source.name;

      return `${mentionTitle} ${this.mention.source.location}`;
    },
  },
};
</script>
